import { gql } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import React from 'react'

import { exportsClient } from '../apollo/api'
import { useBtimeLogger } from '../logger/btimeLogs/log'
import { useOpenExportHistoryModal } from '../routes/modals/modalsActions'

const QUERY = gql`
  query Export($id: ID) {
    export(id: $id) {
      id
      status
      oldDocument
      document {
        id
        src
      }
    }
  }
`

export const useCheckExport = () => {
  const notify = useNotification()
  const openExportHistoryModal = useOpenExportHistoryModal()
  const check = (id, notificationId, times = 1, bulkResumeExport = false) => {
    exportsClient.query({ query: QUERY, variables: { id } }).then(resp => {
      const exportObj = resp.data?.export || {}
      const src = exportObj.oldDocument?.Location || exportObj.document?.src
      const hasError = exportObj.status === 'error'
      const isDone = resp?.data?.export?.status === 'done'

      if (hasError) {
        notify.updateToError(notificationId, {
          title: 'Ocorreu um erro com a exportação',
          message: 'Favor tentar novamente.'
        })
        return
      }

      if (bulkResumeExport && isDone) {
        notify.updateToSuccess(notificationId, {
          title: 'Seu pedido está sendo processado!',
          message:
            'Estamos gerando seu arquivo. Assim que estiver pronto, você receberá um e-mail com o .zip (verifique também a caixa de spam).',
          fixed: true
        })
        return
      }

      if (!!src) {
        notify.updateToSuccess(notificationId, {
          title: 'Arquivo gerado com sucesso!',
          message: 'Clique no botão para fazer o download',
          fixed: true,
          button: {
            label: 'Download',
            href: src,
            target: '_blank',
            download: true
          }
        })
        return
      }

      if (times >= 300) {
        notify.updateToInfo(notificationId, {
          title: 'A exportação está demorando mais do que o esperado',
          message: 'Acompanhe pelo histórico de exportação.',
          fixed: true,
          button: {
            label: 'Abrir histórico',
            onClick: () => openExportHistoryModal()
          }
        })
        return
      }

      let interval = times * 1000
      if (times > 5 && times < 50) interval = 5000
      if (times > 50 && times < 300) interval = 7500

      console.log({ times, interval })

      setTimeout(() => check(id, notificationId, times + 1, bulkResumeExport), interval > 5000 ? 5000 : interval)
    })
  }

  return check
}

export const useQueueExport = (request, entity) => {
  const check = useCheckExport()
  const [loading, setLoading] = React.useState(false)
  const btLogger = useBtimeLogger()

  const notify = useNotification()

  const startExport = () => {
    setLoading(true)
    const notificationId = notify.loading({ title: 'Enviando pedido...' })
    const logData = { name: 'export' + entity || '' }
    request()
      .then(({ result }) => {
        check(result.exportId, notificationId)
        notify.updateToLoading(notificationId, { title: 'Gerando arquivo...' })
      })
      .catch(e => {
        setLoading(false)
        notify.updateToError(notificationId, { title: 'Ocorreu um erro ao gerar o arquivo' })
      })
    // btLogger
    // .call(request, undefined, logData)
    // .then(({ result }) => {
    // check(result.exportId, notificationId)
    // notify.updateToLoading(notificationId, { title: 'Gerando arquivo...' })
    // })
    // .catch(e => {
    // setLoading(false)
    // notify.updateToError(notificationId, { title: 'Ocorreu um erro ao gerar o arquivo' })
    // })
  }

  return [loading, startExport]
}
